export default {
  "NO_DATA": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No data available"])}
}